// @ts-nocheck
import React from "react";
import InfoPageLayout, { InfoSection, InfoList } from "../components/InfoPageLayout";

export default function CommunityGuidelines() {
  return (
    <InfoPageLayout
      title="Community Guidelines"
      subtitle="Standards that keep Cardex safe, respectful, and focused on in-person trades."
      updated="February 7, 2026"
    >
      <InfoSection title="Our Community">
        <p>
          Cardex is a platform for adult traders to coordinate in-person card trades. These guidelines
          help keep our community safe, respectful, and enjoyable for everyone.
        </p>
      </InfoSection>

      <InfoSection title="1. 18+ Requirement">
        <p>
          <strong>Cardex is an adults-only platform.</strong> All users must be 18 years of age or older.
          We facilitate in-person meetups between strangers, which requires adult judgment and
          responsibility.
        </p>
        <p>If we discover an account belongs to a minor, it will be immediately terminated.</p>
      </InfoSection>

      <InfoSection title="2. Respectful Communication">
        <p>When interacting with other traders:</p>
        <InfoList items={[
          "No harassment or hate speech - Be kind and respectful in all communications",
          "No threats or intimidation - Keep discussions civil",
          "No spam - Don't send unsolicited messages or flood the platform",
          "No profanity abuse - Keep language appropriate and professional"
        ]} />
      </InfoSection>

      <InfoSection title="3. Privacy & Safety">
        <p><strong>Do NOT share personal information in messages:</strong></p>
        <InfoList items={[
          "Phone numbers",
          "Email addresses",
          "Home addresses",
          "Social media profiles",
          "Payment information (PayPal, Venmo, etc.)"
        ]} />
        <p>
          Coordinate meetup details through the platform, but <strong>always meet in public places</strong>
          like card shops, cafes, or other well-lit public venues during daylight hours.
        </p>
      </InfoSection>

      <InfoSection title="4. Honest Trading">
        <p>When posting trades:</p>
        <InfoList items={[
          "Accurately describe card condition",
          "Use real photos of your cards",
          "Don't post counterfeit or stolen cards",
          "Honor your trade commitments"
        ]} />
      </InfoSection>

      <InfoSection title="5. Public Meetups Only">
        <p>For your safety:</p>
        <InfoList items={[
          "Always meet in public places",
          "Prefer daytime meetups",
          "Bring a friend if possible",
          "Tell someone where you're going",
          "Trust your instincts - if something feels wrong, cancel the meetup"
        ]} />
      </InfoSection>

      <InfoSection title="6. Reporting Violations">
        <p>If someone violates these guidelines, report them immediately:</p>
        <InfoList items={[
          "Open Account & Safety from the menu",
          "Select Report Abuse and follow the prompts",
          "You can also block users from their profile to prevent further contact"
        ]} />
        <p>
          Our team reviews all reports. Violations may result in warnings, suspensions, or permanent
          bans.
        </p>
      </InfoSection>

      <InfoSection title="7. Consequences">
        <p>Violating these guidelines may result in:</p>
        <InfoList items={[
          "Warning notification",
          "Temporary account suspension",
          "Permanent account ban",
          "Law enforcement notification (for serious violations)"
        ]} />
      </InfoSection>

      <InfoSection>
        <p style={{ textAlign: "center", color: "rgba(255, 255, 255, 0.7)" }}>
          Help us maintain a safe and respectful trading community.
        </p>
        <p className="info-contact">Questions? Contact us from the Account menu.</p>
      </InfoSection>
    </InfoPageLayout>
  );
}
